export default __webpack_public_path__ + "64890aa9ff940dc87e40d277ac9728f5.svg";